import React, { useState, useEffect } from "react";
import {
  postLocalidad as addLocalidad,
  getLocalidades,
} from "../helpers/rutaLocalidades";
import { getProvincias } from "../helpers/rutaProvincias";
import "../css/addlocalidadform.css";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';

const AddLocalidadForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    localidad: "",
    codigopostal: "",
    provincia: "",
  });

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await addLocalidad(formValues);
      console.log("✅ Localidad creada:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultarlo

        setFormValues({
          localidad: "",
          codigopostal: "",
          provincia: "",
        });

        // Si querés cerrar el modal también:
        // setShow(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear localidad:", error);
      // Podés mostrar un modal de error si querés
    }
  };


  const [provincias, setProvincias] = useState({
    data: { provincias: [] },
    loading: true,
  });

  useEffect(() => {
    getProvincias().then((provincias) => {
      console.log("📦 Provincias cargadas:", provincias); // Agregá este log
      setProvincias({
        data: provincias,
        loading: false,
      });
    });
  }, []);

  return (
    <>
      {!provincias.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-6">
                <label className="">Localidad</label>
                <input
                  type="text"
                  className="form-control"
                  name="localidad"
                  maxLength="50"
                  required
                  value={formValues.localidad}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label className="">Código Postal</label>
                <input
                  type="text"
                  className="form-control"
                  name="codigopostal"
                  maxLength="4"
                  required
                  value={formValues.codigopostal}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-4">
                <label className="">Provincia</label>
                <select
                  className="form-control"
                  name="provincia"
                  value={formValues.provincia}
                  onChange={handleChange}
                  required
                >
                  <option value="">Elija opción</option>
                  {Array.isArray(provincias.data.provincias) && provincias.data.ok &&
                    provincias.data.provincias.map((provincia) => (
                      <option key={provincia._id} value={provincia._id}>
                        {provincia.provincia}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      )}

        <Modal
          show={showSuccess}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="animate__animated animate__fadeInDown"
        >
          <Modal.Body className="text-center">
            <div style={{ fontSize: "3rem" }}>🖐</div>
            <h5 className="mt-2">¡Registro generado correctamente!</h5>
            </Modal.Body>
        </Modal>
      
    </>
  );
};

export default AddLocalidadForm;
